import {configMt} from "../../constant/initDrawing";
import MainMTWrapper from "../../components/live2/mt/MainMTWrapper";

const Live2MTPage = () => <MainMTWrapper config={configMt}/>

export default Live2MTPage;